import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { Form, Field } from 'lib/form/form';
import FormView from 'lib/form/form-view';
import Localizable from 'lib/intl/localizable';
import withDialog from 'lib/alerts/with-dialog';
import { ValueFieldData } from 'lib/form/value-field-data';

import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';
import Styled from 'styled';

import defaultStyles from './edit-my-bazaar-view.scss';
import buttonStyles from './button-view.scss';
import formStyles from './form-view.scss';

class EditMyBazaarForm extends Form {
    constructor(options) {
        const { info = '' } = options;
        super({
            ...options,
            field: {
                info: new Field({
                    data: new ValueFieldData({
                        value: info,
                    }),
                }),
            },
        });
    }
}

export class EditMyBazaarViewModel {
    bazaarProfileStore: MyBazaarStore;

    @observable form: Form;
    @observable loading = false;

    constructor(bazaarProfileStore) {
        this.bazaarProfileStore = bazaarProfileStore;
    }

    handleSubmit = ({ data }) => {
        const { info } = data;
        return this.bazaarProfileStore.edit(info);
    };

    @action setupForm = info => {
        const form = new EditMyBazaarForm({
            info,
            handleSubmit: this.handleSubmit,
        });
        this.form = form;
        return form;
    };
}

@withStackViewForm({ hideAction: true, title: <FormattedMessage id='MY_BAZAAR_FORM_TITLE' />, genericSubmit: true })
@withDialog
@Localizable()
@Styled(defaultStyles)
@observer
class EditMyBazaarView extends React.Component {
    render() {
        const { form, styles } = this.props;

        return (
            <FormView form={form} submitOnEnter={false} submit={this.submit} style={{ form: formStyles.form }}>
                <div className={styles.fieldWrapper} key='info'>
                    <FieldWithLabelView
                        key='info'
                        id='bazaar-description'
                        field={
                            <TextAreaView
                                style={{ textArea: styles.textArea }}
                                field={form.field.get('info')}
                                type='text'
                                emojify={false}
                            />
                        }
                        label={<FormattedMessage id='ADD_DESCRIPTION' />}
                    />
                </div>
            </FormView>
        );
    }
}

export default EditMyBazaarView;
